import { render, staticRenderFns } from "./CombinationProductIndex.vue?vue&type=template&id=4e17cdcf&scoped=true&"
import script from "./CombinationProductIndex.vue?vue&type=script&lang=js&"
export * from "./CombinationProductIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e17cdcf",
  null
  
)

export default component.exports